var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.dialog
        ? _c("GroupModal", {
            attrs: {
              dialog: _vm.dialog,
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
            },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
              refetch: function ($event) {
                return _vm.$emit("refetch")
              },
            },
          })
        : _vm._e(),
      _c("UiButton", {
        attrs: {
          disabled: _vm.noCompany,
          size: _vm.size,
          buttonText: _vm.text,
          variant: "blue",
          id: "newGroup",
        },
        on: { click: _vm.toggle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }